import React from "react";
import PropTypes from "prop-types";
import { DesktopMenu } from "./DesktopMenu";
import { MobileMenu } from "./MobileMenu";
import { Responsive } from "../../index";

export var TopMenu = function TopMenu(props) {
  if (props.topbarOnMobile) {
    return React.createElement(DesktopMenu, props);
  } else {
    return React.createElement(
      React.Fragment,
      null,
      React.createElement(
        Responsive,
        { show: "desktop" },
        React.createElement(DesktopMenu, props)
      ),
      React.createElement(
        Responsive,
        { hide: "desktop" },
        React.createElement(MobileMenu, props)
      )
    );
  }
};

TopMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  menuContent: PropTypes.object.isRequired,
  ctaToggle: PropTypes.bool,
  startTransparent: PropTypes.bool,
  hideCTA: PropTypes.bool,
  topbarOnMobile: PropTypes.bool,
  wrapLink: PropTypes.func,
  wrapLinkLogo: PropTypes.func,
  logoVariant: PropTypes.oneOf(["PinkNavy", "NavyPink", "NavyLightPink"]),
  currentPathname: PropTypes.string,
  pushdownNotification: PropTypes.any
} : {};

TopMenu.defaultProps = {
  ctaToggle: false,
  startTransparent: false,
  hideCTA: false,
  topbarOnMobile: false,
  logoVariant: "NavyPink",
  wrapLink: function wrapLink(link, linkProps) {
    return React.createElement(
      "a",
      { key: linkProps.url, href: linkProps.url },
      link
    );
  },
  wrapLinkLogo: function wrapLinkLogo(content) {
    return React.createElement(
      "a",
      { href: "/", title: "Anyfin" },
      content
    );
  },
  currentPathname: "/no-url-supplied",
  pushdownNotification: function pushdownNotification() {
    return null;
  }
};